import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
    const navigate = useNavigate();
    const { exchangeGoogleSession } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(match[1]);
        (async () => {
            try {
                await exchangeGoogleSession(session_id);
                window.history.replaceState(null, "", window.location.pathname);
                toast.success("Erfolgreich angemeldet");
                navigate("/verlag-waehlen", { replace: true });
            } catch (e) {
                toast.error("Anmeldung fehlgeschlagen");
                navigate("/login", { replace: true });
            }
        })();
    }, [exchangeGoogleSession, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
            <div className="flex flex-col items-center gap-3">
                <div className="h-10 w-10 rounded-full border-2 border-tenant border-t-transparent animate-spin" />
                <span className="text-sm tracking-widest uppercase">Authentifiziere…</span>
            </div>
        </div>
    );
}
